// extracted by mini-css-extract-plugin
export default {"faqQuestion":"FaqElement_faqQuestion__5-0xC","faqIcon":"FaqElement_faqIcon__j8yFZ","faqImage":"FaqElement_faqImage__AIfK+"};